import React from "react";
import { Collapse } from "reactstrap";
import classNames from 'classnames';
import 'react-datepicker/dist/react-datepicker.css'

import { Row, Column } from "../../components/Layout";
import PageWithModal from "../../components/Page/PageWithModal";
import FilterAndSearch from "../../components/FilterAndSearch";
import { roles } from "../../constants";
import { profileIcon30 as smallIcon, profileIcon50 as bigIcon } from "img/icons";
import styles from "./style.module.scss";


export default class DashboardPage extends React.Component {
	state = {
		selected:null,
		filters:["Amministratori", "utenti"],
		collapse:null
	};

	componentDidMount() {
		this.props.listUsers();
	}

	userPill = (user) => {
		let isOpen = this.state.collapse === user.id;
		let isHover = this.state.isHover === user.id;
		return <div
			key={user.id}
			onClick={() => {this.setState({collapse: isOpen ? null : user.id})}}
			className={classNames(styles.userPill, isOpen ? styles.open : null )}
		>
			<div
			     onMouseOver={() => this.setState({isHover:user.id}) }
			     onMouseOut={() => this.setState({isHover:null})}
			     className={styles.header}>
				<div className={styles.flex1}>
					<img style={isOpen ? null : {height:30, width:30}} src={isHover || isOpen ?  bigIcon : smallIcon} alt={"user icon"}/>
				</div>
				<div className={styles.flex2}>{isOpen ? "UTENTE" : `${user.firstName} ${user.lastName}`}</div>
				<div className={classNames(styles.flex1, styles.flexend)}>
					{isOpen ?
						<i className={classNames(styles.white, "fa","fa-angle-up")} aria-hidden="true"/> :
						<i  className={classNames(isHover ? styles.white : styles.red,"fa","fa-angle-down")} aria-hidden="true"/>
					}
				</div>
			</div>
			<Collapse isOpen={isOpen}>
				<Row>
					<div className={"field"}>
						{user.firstName}
					</div>
					<div className={"field"}>
						{user.lastName}
					</div>
				</Row>
				<div className={"field"}>{user.email}</div>

			</Collapse>
		</div>;

	};

	render() {

		let {selected, search, filters} = this.state;
		let data = this.props.users.filter(u => !roles.isSuperUser(u));
		if(selected) {
			let role = selected === "Amministratori" ? roles.names.ADMIN : roles.names.USER;
			data = data.filter(u => u.role.name === role);
		}

		if(search) {
			data = data.filter(u => (u.firstName && u.firstName.toLocaleLowerCase().includes(search)) ||
					(u.lastName && u.lastName.toLocaleLowerCase().includes(search)) ||
					(u.email && u.email.toLocaleLowerCase().includes(search))
			)
		}

		return (
			<PageWithModal
				message={this.state.message}
				confirm={this.state.confirm}
				{...this.props}
				error={this.state.error||this.props.error}
			>
				<FilterAndSearch
					filter={filters}
					onFilter={(selected) => this.setState({selected})}
					onSearch={search => this.setState({search})}
					selected={selected}
				/>
				<Row className={styles.space}>
					<Column className={classNames(styles.bodycol, styles.left)}>
					{
						data.slice(0, Math.ceil(data.length/2)).map(u => this.userPill(u))
					}
					</Column>
					<Column className={classNames(styles.bodycol, styles.right)}>
					{
						data.slice(Math.ceil(data.length/2), data.length).map(u => this.userPill(u))
					}
					</Column>
				</Row>
			</PageWithModal>
		);
	}
}
